import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd8ed53"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "shippingForm",
  class: "p-6 mb-4 card sm:p-8"
}
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "relative w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full title-main" }, "การจัดส่ง และที่อยู่ผู้รับ")
], -1))
const _hoisted_5 = { class: "flex flex-col p-0 py-4 sm:p-6" }
const _hoisted_6 = { class: "flex flex-col items-start h-auto gap-3 mb-7 lg:flex-row lg:gap-0 lg:items-center lg:h-10" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-none w-full text-base text-gray-400 lg:w-32" }, [
  /*#__PURE__*/_createTextVNode(" ผู้รับ "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_8 = { class: "flex items-center gap-4 sm:flex-1" }
const _hoisted_9 = { class: "grid w-full grid-cols-2 gap-4 md:grid-cols-3 2xl:grid-cols-4" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_13 = { class: "relative flex flex-col" }
const _hoisted_14 = { class: "flex flex-col items-start h-auto gap-3 mb-7 lg:flex-row lg:gap-0 lg:items-center lg:h-10" }
const _hoisted_15 = { class: "flex-none w-full text-base text-gray-400 lg:w-32" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" ที่อยู่ ")
const _hoisted_17 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_18 = { class: "relative flex flex-col w-full" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_21 = { class: "flex flex-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 hidden w-16 sm:w-32 lg:block" }, null, -1))
const _hoisted_23 = { class: "w-full" }
const _hoisted_24 = { class: "flex flex-col gap-0 md:flex-row md:gap-4" }
const _hoisted_25 = { class: "relative flex flex-col w-full" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_28 = { class: "relative flex flex-col w-full" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_31 = { class: "flex flex-col gap-0 md:flex-row md:gap-4" }
const _hoisted_32 = { class: "relative flex flex-col w-full" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_35 = { class: "relative flex flex-col w-full" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_38 = { class: "flex flex-col items-start h-auto gap-3 mb-7 lg:flex-row lg:gap-0 lg:items-center lg:h-10" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-none w-24 text-base text-gray-400 sm:w-32" }, [
  /*#__PURE__*/_createTextVNode(" เบอร์โทร "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_40 = { class: "grid w-full grid-cols-1 gap-4 md:grid-cols-3 2xl:grid-cols-4" }
const _hoisted_41 = { class: "col-span-1" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_44 = { class: "flex flex-col items-start h-auto gap-3 mb-7 lg:flex-row lg:gap-0 lg:items-center lg:h-10" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-none w-24 text-base text-gray-400 sm:w-32" }, "อีเมล", -1))
const _hoisted_46 = { class: "grid w-full grid-cols-1 gap-4 md:grid-cols-3 2xl:grid-cols-4" }
const _hoisted_47 = { class: "col-span-1" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = {
  key: 0,
  class: "absolute flex items-center gap-1 mt-1 text-red-500"
}
const _hoisted_50 = {
  key: 0,
  class: "flex flex-col space-y-4"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "flex-auto text-base text-gray-400" }, [
  /*#__PURE__*/_createTextVNode(" เลือกการจัดส่งสินค้า "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*")
], -1))
const _hoisted_52 = { class: "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" }
const _hoisted_53 = ["id", "onClick"]
const _hoisted_54 = { class: "flex items-center h-full space-x-4" }
const _hoisted_55 = { class: "relative" }
const _hoisted_56 = ["src", "onerror"]
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "flex flex-col w-full gap-1 text-left" }
const _hoisted_59 = { class: "flex justify-between" }
const _hoisted_60 = { class: "clamp-1" }
const _hoisted_61 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_62 = { class: "text-xs text-gray-500" }
const _hoisted_63 = { class: "text-xs text-gray-500" }
const _hoisted_64 = ["id", "onClick"]
const _hoisted_65 = { class: "flex items-center h-full space-x-4" }
const _hoisted_66 = { class: "relative" }
const _hoisted_67 = ["src", "onerror"]
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "flex flex-col w-full gap-1 text-left" }
const _hoisted_70 = { class: "flex justify-between" }
const _hoisted_71 = { class: "clamp-1" }
const _hoisted_72 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_73 = { class: "text-xs text-gray-500" }
const _hoisted_74 = { class: "text-xs text-gray-500" }
const _hoisted_75 = {
  key: 2,
  class: "absolute right-1 bottom-2"
}
const _hoisted_76 = { class: "relative col-info" }
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "absolute bottom-0 z-40 popoverIcon right-2 md:left-2" }
const _hoisted_79 = { class: "m-2 custom-input-trigger w-60 sm:w-80" }
const _hoisted_80 = { class: "flex flex-col" }
const _hoisted_81 = { class: "mt-4" }
const _hoisted_82 = { class: "p-3 bg-white border rounded-md" }
const _hoisted_83 = {
  key: 0,
  class: "flex flex-row my-1"
}
const _hoisted_84 = { class: "text-sm" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_86 = {
  key: 3,
  class: "absolute right-1 bottom-2"
}
const _hoisted_87 = { class: "relative col-info" }
const _hoisted_88 = ["src"]
const _hoisted_89 = { class: "absolute bottom-0 z-40 popoverIcon right-2 md:left-2" }
const _hoisted_90 = { class: "m-2 custom-input-trigger w-60 sm:w-80" }
const _hoisted_91 = { class: "flex flex-col" }
const _hoisted_92 = { class: "mt-4" }
const _hoisted_93 = { class: "p-3 bg-white border rounded-md" }
const _hoisted_94 = { class: "flex flex-row" }
const _hoisted_95 = {
  key: 0,
  class: "w-1/2 text-base font-semibold text-center text-gray-500"
}
const _hoisted_96 = {
  key: 1,
  class: "w-1/2 text-base font-semibold text-center text-gray-500"
}
const _hoisted_97 = {
  key: 2,
  class: "w-1/2 text-base font-semibold text-center text-gray-500"
}
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-1/2 text-base font-semibold text-center text-gray-500" }, " ค่าจัดส่ง ", -1))
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_100 = { class: "flex flex-row my-1" }
const _hoisted_101 = { class: "w-1/2 text-sm text-center" }
const _hoisted_102 = { class: "w-1/2 text-sm text-center" }
const _hoisted_103 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_105 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_106 = { class: "w-1/2 text-sm text-center" }
const _hoisted_107 = { class: "w-1/2 text-sm text-center" }
const _hoisted_108 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_110 = { class: "flex flex-row mt-3" }
const _hoisted_111 = { class: "text-sm" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_113 = { class: "flex flex-row my-1" }
const _hoisted_114 = { class: "w-1/2 text-sm text-center" }
const _hoisted_115 = { class: "w-1/2 text-sm text-center" }
const _hoisted_116 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_118 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_119 = { class: "w-1/2 text-sm text-center" }
const _hoisted_120 = { class: "w-1/2 text-sm text-center" }
const _hoisted_121 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_123 = { class: "flex flex-row mt-3" }
const _hoisted_124 = { class: "text-sm" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_126 = { class: "flex flex-row my-1" }
const _hoisted_127 = { class: "w-1/2 text-sm text-center" }
const _hoisted_128 = { class: "w-1/2 text-sm text-center" }
const _hoisted_129 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_131 = {
  key: 1,
  class: "flex flex-row my-1"
}
const _hoisted_132 = { class: "w-1/2 text-sm text-center" }
const _hoisted_133 = { class: "w-1/2 text-sm text-center" }
const _hoisted_134 = /*#__PURE__*/_createTextVNode(" จัดส่งฟรี ")
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_136 = { class: "flex flex-row mt-3" }
const _hoisted_137 = { class: "text-sm" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_140 = { key: 0 }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "absolute flex items-center gap-1 mt-1 text-red-500" }, /*#__PURE__*/_toDisplayString("* กรุณาเลือกการจัดส่งสินค้า"), -1))
const _hoisted_142 = [
  _hoisted_141
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThailandAutoComplete = _resolveComponent("ThailandAutoComplete")!
  const _component_shippingConfirmDialog = _resolveComponent("shippingConfirmDialog")!

  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            class: "bullet_main",
            src: require('@/assets/icon_bullet/shipping.svg'),
            alt: ""
          }, null, 8, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("form", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass([
                  _ctx.formShipping.firstname.error ? 'inputError' : 'inputBorder'
                , "w-full p-3 border rounded-md"]),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formShipping.firstname.value) = $event)),
                    onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.watch('firstname'))),
                    placeholder: "ชื่อจริง",
                    type: "text"
                  }, null, 34), [
                    [_vModelText, _ctx.formShipping.firstname.value]
                  ]),
                  (_ctx.formShipping.firstname.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_ctx.formShipping.firstname.error)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.formShipping.firstname.error), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "นามสกุล",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formShipping.lastname.value) = $event)),
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.watch('lastname'))),
                    type: "text",
                    class: "w-full p-3 border rounded-md inputBorder"
                  }, null, 544), [
                    [_vModelText, _ctx.formShipping.lastname.value]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, [
              _hoisted_16,
              (this.validatePickup())
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, "*"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "ที่อยู่",
                class: _normalizeClass([_ctx.formShipping.address.error ? 'inputError' : 'inputBorder', "w-full p-3 border rounded-md"]),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formShipping.address.value) = $event)),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.watch('address'))),
                type: "text"
              }, null, 34), [
                [_vModelText, _ctx.formShipping.address.value]
              ]),
              (_ctx.formShipping.address.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_ctx.formShipping.address.error)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(_ctx.formShipping.address.error), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ThailandAutoComplete, {
                    modelValue: _ctx.formShipping.tambon.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formShipping.tambon.value) = $event)),
                    value: _ctx.formShipping.tambon.value,
                    type: "district",
                    onSelect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.select($event))),
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.tambon))),
                    label: "ตำบล",
                    size: "medium",
                    placeholder: "ตำบล"
                  }, {
                    validator: _withCtx(() => [
                      (_ctx.formShipping.tambon.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            (_ctx.formShipping.tambon.error)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_27, _toDisplayString(_ctx.formShipping.tambon.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_ThailandAutoComplete, {
                    modelValue: _ctx.formShipping.amphoe.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formShipping.amphoe.value) = $event)),
                    value: _ctx.formShipping.amphoe.value,
                    type: "amphoe",
                    onSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.select($event))),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.amphoe))),
                    label: "อำเภอ",
                    size: "medium",
                    placeholder: "อำเภอ"
                  }, {
                    validator: _withCtx(() => [
                      (_ctx.formShipping.amphoe.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            (_ctx.formShipping.amphoe.error)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(_ctx.formShipping.amphoe.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_ThailandAutoComplete, {
                    modelValue: _ctx.formShipping.province.value,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formShipping.province.value) = $event)),
                    value: _ctx.formShipping.province.value,
                    type: "province",
                    onSelect: _cache[13] || (_cache[13] = ($event: any) => (_ctx.select($event))),
                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.province))),
                    label: "จังหวัด",
                    size: "medium",
                    color: "#35495e",
                    placeholder: "จังหวัด"
                  }, {
                    validator: _withCtx(() => [
                      (_ctx.formShipping.province.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                            (_ctx.formShipping.province.error)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.formShipping.province.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_ThailandAutoComplete, {
                    modelValue: _ctx.formShipping.postalcode.value,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formShipping.postalcode.value) = $event)),
                    value: _ctx.formShipping.postalcode.value,
                    type: "zipcode",
                    onSelect: _cache[16] || (_cache[16] = ($event: any) => (_ctx.select($event))),
                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeAddress($event, _ctx.formShipping.postalcode))),
                    label: "รหัสไปรษณีย์",
                    size: "medium",
                    color: "#00a4e4",
                    placeholder: "รหัสไปรษณีย์"
                  }, {
                    validator: _withCtx(() => [
                      (_ctx.formShipping.postalcode.error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_ctx.formShipping.postalcode.error)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(_ctx.formShipping.postalcode.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "value"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  placeholder: "เบอร์โทร",
                  class: _normalizeClass([_ctx.formShipping.phone.error ? 'inputError' : 'inputBorder', "w-full p-3 border rounded-md"]),
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formShipping.phone.value) = $event)),
                  onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.acceptNumber && _ctx.acceptNumber(...args))),
                  type: "text",
                  maxlength: "12"
                }, null, 34), [
                  [_vModelText, _ctx.formShipping.phone.value]
                ]),
                (_ctx.formShipping.phone.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      (_ctx.formShipping.phone.error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_43, _toDisplayString(_ctx.formShipping.phone.error), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _withDirectives(_createElementVNode("input", {
                  placeholder: "อีเมล",
                  class: _normalizeClass([_ctx.formShipping.email.error ? 'inputError' : 'inputBorder', "w-full p-3 border rounded-md"]),
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formShipping.email.value) = $event)),
                  onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.watch('email'))),
                  type: "text"
                }, null, 34), [
                  [_vModelText, _ctx.formShipping.email.value]
                ]),
                (_ctx.formShipping.email.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      (_ctx.formShipping.email.error)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_49, _toDisplayString(_ctx.formShipping.email.error), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (!_ctx.data.hasNoShipment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shippingData, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.shippingMethodId,
                      class: "relative"
                    }, [
                      (_ctx.shippingData.length == 1)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            id: item.shippingMethodId,
                            onClick: ($event: any) => (_ctx.selectShipping(item.shippingMethodId, item, _ctx.data)),
                            class: "w-full h-full p-1 border rounded-md cursor-pointer border-green-island-500 bg-green-island-100"
                          }, [
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("img", {
                                  class: "object-contain bg-white bg-center bg-no-repeat bg-contain border border-gray-100 rounded-md min-w-14 max-w-14 min-h-14 max-h-14",
                                  src: _ctx.envMedia + '/public/' + item.shippingIconUrl,
                                  onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                                }, null, 8, _hoisted_56),
                                (item.isCOD)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                      class: "absolute right-0 top-1",
                                      src: require('@/assets/images/icon-cod2.png')
                                    }, null, 8, _hoisted_57))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("p", _hoisted_60, _toDisplayString(item.shippingAliasName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_61, [
                                  _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.setData(item)), 1),
                                  _createElementVNode("p", _hoisted_63, " ระยะเวลาจัดส่ง " + _toDisplayString(item.deliveryTime.earliest) + " - " + _toDisplayString(item.deliveryTime.last) + " วัน ", 1)
                                ])
                              ])
                            ])
                          ], 8, _hoisted_53))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            id: item.shippingMethodId,
                            onClick: ($event: any) => (_ctx.selectShipping(item.shippingMethodId, item, _ctx.data)),
                            class: _normalizeClass([
                  _ctx.inpRadShipping === item.shippingMethodId
                    ? 'border-green-island-500  bg-green-island-100'
                    : ''
                , "w-full h-full p-1 border-2 border-gray-100 rounded-md cursor-pointer"])
                          }, [
                            _createElementVNode("div", _hoisted_65, [
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("img", {
                                  class: "object-contain bg-white bg-center bg-no-repeat bg-contain border border-gray-100 rounded-md min-w-14 max-w-14 min-h-14 max-h-14",
                                  src: _ctx.envMedia + '/public/' + item.shippingIconUrl,
                                  onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                                }, null, 8, _hoisted_67),
                                (item.isCOD)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                      class: "absolute right-0 top-1",
                                      src: require('@/assets/images/icon-cod2.png')
                                    }, null, 8, _hoisted_68))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_69, [
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("p", _hoisted_71, _toDisplayString(item.shippingAliasName), 1)
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.setData(item)), 1),
                                  _createElementVNode("p", _hoisted_74, " ระยะเวลาจัดส่ง " + _toDisplayString(item.deliveryTime.earliest) + " - " + _toDisplayString(item.deliveryTime.last) + " วัน ", 1)
                                ])
                              ])
                            ])
                          ], 10, _hoisted_64)),
                      (
                (item.shippingMethodType == 'fixedRate' ||
                  item.shippingMethodType == 'basedByPcs') &&
                item.shippingMethodAttribute.minOrderTotalAmount > 0
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("img", {
                                class: "w-4 h-4",
                                src: require('@/assets/images/question_showship.svg'),
                                alt: ""
                              }, null, 8, _hoisted_77),
                              _createElementVNode("div", _hoisted_78, [
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _createElementVNode("div", _hoisted_81, [
                                      _createElementVNode("div", _hoisted_82, [
                                        (
                                item.shippingMethodAttribute.minOrderTotalAmount
                              )
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                              _createElementVNode("p", _hoisted_84, [
                                                _hoisted_85,
                                                _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                      item.shippingMethodAttribute
                                        .minOrderTotalAmount
                                    )) + " บาท จัดส่งฟรี ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                item.shippingMethodType == 'basedByStepPcs' ||
                item.shippingMethodType == 'basedByStepWeight' ||
                item.shippingMethodType == 'basedByOrderPrice'
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("img", {
                                class: "w-4 h-4",
                                src: require('@/assets/images/question_showship.svg'),
                                alt: ""
                              }, null, 8, _hoisted_88),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("div", _hoisted_90, [
                                  _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("div", _hoisted_92, [
                                      _createElementVNode("div", _hoisted_93, [
                                        _createElementVNode("div", _hoisted_94, [
                                          (item.shippingMethodType == 'basedByStepPcs')
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_95, " คิดตามจำนวนสินค้า "))
                                            : _createCommentVNode("", true),
                                          (
                                item.shippingMethodType == 'basedByStepWeight'
                              )
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_96, " น้ำหนักสินค้า "))
                                            : _createCommentVNode("", true),
                                          (
                                item.shippingMethodType == 'basedByOrderPrice'
                              )
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_97, " ราคาสินค้ารวม "))
                                            : _createCommentVNode("", true),
                                          _hoisted_98
                                        ]),
                                        _hoisted_99,
                                        (item.shippingMethodType == 'basedByStepPcs')
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                .shippingMethodAttribute.shippingCost, (itemA, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: itemA.shippingMethodId
                                                }, [
                                                  (
                                  index !=
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("div", _hoisted_100, [
                                                          _createElementVNode("p", _hoisted_101, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemA.minPcs)) + " ชิ้น ", 1),
                                                          _createElementVNode("p", _hoisted_102, [
                                                            (itemA.shippingCost)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _hoisted_103
                                                                ], 64))
                                                          ])
                                                        ]),
                                                        _hoisted_104
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (
                                  index ==
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                        _createElementVNode("p", _hoisted_106, " เกิน " + _toDisplayString(_ctx.currency(itemA.minPcs)) + " ชิ้นขึ้นไป ", 1),
                                                        _createElementVNode("p", _hoisted_107, [
                                                          (itemA.shippingCost)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.currency(itemA.shippingCost)) + " บาท ", 1)
                                                              ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _hoisted_108
                                                              ], 64))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128)),
                                              (
                                item.shippingMethodAttribute.minOrderTotalAmount
                              )
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_109,
                                                    _createElementVNode("div", _hoisted_110, [
                                                      _createElementVNode("p", _hoisted_111, [
                                                        _hoisted_112,
                                                        _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                      item.shippingMethodAttribute
                                        .minOrderTotalAmount
                                    )) + " บาท จัดส่งฟรี ", 1)
                                                      ])
                                                    ])
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (
                              item.shippingMethodType == 'basedByStepWeight'
                            )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                .shippingMethodAttribute.shippingCost, (itemB, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: itemB.shippingMethodId
                                                }, [
                                                  (
                                  index !=
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("div", _hoisted_113, [
                                                          _createElementVNode("p", _hoisted_114, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemB.minWeight)) + " กิโลกรัม ", 1),
                                                          _createElementVNode("p", _hoisted_115, [
                                                            (itemB.shippingCost)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _hoisted_116
                                                                ], 64))
                                                          ])
                                                        ]),
                                                        _hoisted_117
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (
                                  index ==
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                                                        _createElementVNode("p", _hoisted_119, " เกิน " + _toDisplayString(_ctx.currency(itemB.minWeight)) + " กิโลกรัม ขึ้นไป ", 1),
                                                        _createElementVNode("p", _hoisted_120, [
                                                          (itemB.shippingCost)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.currency(itemB.shippingCost)) + " บาท ", 1)
                                                              ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _hoisted_121
                                                              ], 64))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128)),
                                              (
                                item.shippingMethodAttribute.minOrderTotalAmount
                              )
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_122,
                                                    _createElementVNode("div", _hoisted_123, [
                                                      _createElementVNode("p", _hoisted_124, [
                                                        _hoisted_125,
                                                        _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                      item.shippingMethodAttribute
                                        .minOrderTotalAmount
                                    )) + " บาท จัดส่งฟรี ", 1)
                                                      ])
                                                    ])
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true),
                                        (
                              item.shippingMethodType == 'basedByOrderPrice'
                            )
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item
                                .shippingMethodAttribute.shippingCost, (itemC, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, {
                                                  key: itemC.shippingMethodId
                                                }, [
                                                  (
                                  index !=
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createElementVNode("div", _hoisted_126, [
                                                          _createElementVNode("p", _hoisted_127, " ไม่เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ", 1),
                                                          _createElementVNode("p", _hoisted_128, [
                                                            (itemC.shippingCost)
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1)
                                                                ], 64))
                                                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                  _hoisted_129
                                                                ], 64))
                                                          ])
                                                        ]),
                                                        _hoisted_130
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (
                                  index ==
                                  item.shippingMethodAttribute.shippingCost
                                    .length -
                                    1
                                )
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                                        _createElementVNode("p", _hoisted_132, " เกิน " + _toDisplayString(_ctx.currency(itemC.minOrderTotalAmount)) + " บาท ขึ้นไป ", 1),
                                                        _createElementVNode("p", _hoisted_133, [
                                                          (itemC.shippingCost)
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.currency(itemC.shippingCost)) + " บาท ", 1)
                                                              ], 64))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _hoisted_134
                                                              ], 64))
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128)),
                                              (
                                item.shippingMethodAttribute.minOrderTotalAmount
                              )
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _hoisted_135,
                                                    _createElementVNode("div", _hoisted_136, [
                                                      _createElementVNode("p", _hoisted_137, [
                                                        _hoisted_138,
                                                        _createTextVNode(" มูลค่าหลังหักส่วนลดเกิน " + _toDisplayString(_ctx.currency(
                                      item.shippingMethodAttribute.minOrderTotalAmount
                                    )) + " บาท จัดส่งฟรี ", 1)
                                                      ])
                                                    ])
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _hoisted_139,
                (!_ctx.inpRadShipping)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_140, _hoisted_142))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_shippingConfirmDialog, { ref: "shippingDialog" }, null, 512)
        ])
      ]))
    : _createCommentVNode("", true)
}